import { render, staticRenderFns } from "./AuthSignupConfirmPracticeModal.vue?vue&type=template&id=1b2726ff"
import script from "./AuthSignupConfirmPracticeModal.vue?vue&type=script&lang=js"
export * from "./AuthSignupConfirmPracticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports